export default "__VITE_ASSET__DLdYtPUX__"